import React from 'react';
import Modal from 'react-modal';
import { toast } from 'react-hot-toast';
import { sheetSend } from '../../../services/kojaServices';
import Swal from 'sweetalert2';
const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };
  
  // Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
  Modal.setAppElement("#root");

const ClearingModal = ({Open,setOpen , Checkout ,sheetId}) => {
    
    
      function closeModal() {
        setOpen(false);
      }

      const sendData = async() => {
            try{
               let x = document.getElementById("select").value
               if(x==='Cash' || x==='Pos' || x==='Online'){
                let data 
                data = {
                  sheetId : sheetId,
                  clearingMethod : x}
                console.log(data)
                console.log(data)
                const {data : send} = await sheetSend(data)
                console.log(send)
                Swal.fire({
                  icon: 'success',
                  title: `صورت کارشناسی با موفقیت برای کاربر ارسال شد`,
                  showConfirmButton: false,
                  timer: 2000
                })
                closeModal()
                window.location.reload()
               }else{
                toast.error("لطفا نوع تسویه حساب رو انتخاب کنید")
               }
            }catch(err){
                console.log(err)
                toast.error("خطایی رخ داده است مجدد تلاش کنید")
            }
      }
    return (
        <div>
        <Modal
        isOpen={Open}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <h2>لطفا نوع تسویه حساب رو انتخاب کنید</h2>
       <div className='text-end'>
       <p>مبلغ نهایی کارشناسی : {Checkout.userPrice.toLocaleString()} تومان است</p>
       <p>که مبلغ پرداخت شده: {Checkout.prepayment.toLocaleString()} تومان پرداخت شده است</p>
       <p>لطفا نحوه دریافت باقی مانده یعنی مبلغ باقی مانده: {Checkout.remaining.toLocaleString()} تومان را مشخص کنید</p>
       </div>
       <div>
       <select id='select' className='form-select w-100'>
       <option>نوع تسویه حساب مشتری</option>
       <option value='Cash'>نقدی</option>
       <option value='Pos'>کارت عابر بانک</option>
       <option value='Online'>آنلاین</option>
       </select>
       </div>
       <button className='mt-3 ms-3 btn btn-primary' onClick={()=> {sendData()}}>تایید</button>
        <button className='mt-3 btn btn-primary' onClick={closeModal}>انصراف</button>        
      </Modal>
        </div>
    );
};

export default ClearingModal;